import {useState,useEffect} from 'react'
import Map, {Source, Layer,Marker,GeoJSONSource  } from 'react-map-gl';
import {colors} from '../utils/colorDict'
const ClusterLayer=({filterString,mergedMediaData,featureData})=>{
const [clusterOpacity, setClusterOpacity] = useState(0)
//const [featureData, setFeatureData] = useState([])

useEffect(() => {
  setTimeout(() => {
    setClusterOpacity(1)  
  }, 500);
}, [])

    const featureCollection = {
        type: 'FeatureCollection',
        features: featureData
      };
 
    return <Source
    id="cluster-layer"
    type="geojson"
    data={featureCollection}
    cluster={true}

  ><>
  {/* <Layer id={'clusters'}
  type={'circle'}
  source={'cluster-layer'}
   filter={['has', 'point_count']}
  paint={{
    'circle-color': [ 'match',['get', 'mediatype'],1, colors[1],2,colors[2],3,colors[3], colors.default],          
    'circle-radius': ['step', ['get', 'point_count'], 20, 100, 30, 750, 40],
    "circle-opacity": clusterOpacity,
    "circle-opacity-transition": {duration: 4000},
    "circle-radius-transition": {duration: 4000},
  } }
    /> */}
    {/* <Layer 
      id={'cluster-count'}
      type={'symbol'}
      source={'cluster-layer'}
       filter={['has', 'point_count']}
      layout={{
        'text-field': '{point_count_abbreviated}',
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 12
      }}
    /> */}
    <Layer 
        id={'unclustered-point'}
        type={'circle'}
        source={'cluster-layer'}
        filter={['!', ['has', 'point_count']]}
        paint={{
          'circle-color': filterString ? "red" : [ 'match',['get', 'mediatype'],1, colors[1],2,colors[2],3,colors[3], colors.default],          
          'circle-radius': filterString ? 9 : 6,
          'circle-stroke-width': 1,
          'circle-stroke-color': '#fff',
          "circle-opacity": clusterOpacity,
          "circle-color-transition": {duration: 2000},
          "circle-opacity-transition": {duration: 4000},
          "circle-radius-transition": {duration: 4000},
        }}
      /> 
      </>
      </Source>
}

export default ClusterLayer